import { keyBy } from 'lodash';
import createReducer from 'shared/utils/createReducer';
import requestsStatuses from 'modules/common/constants/requestsStatuses';


import {
  FETCH_APPOINTMENTS_ESTIMATED_TIME,
  UPDATE_ESTIMATED_TIME,
} from '../actions/appointmentsEstimatesTimeToBeServed';


const defaultState = {
  status: requestsStatuses.default,
  value: {},
};

export default createReducer(defaultState, {
  [FETCH_APPOINTMENTS_ESTIMATED_TIME.pending]: (state) => ({
    ...state,
    status: requestsStatuses.pending,
  }),

  [FETCH_APPOINTMENTS_ESTIMATED_TIME.failure]: (state) => ({
    ...state,
    status: requestsStatuses.failure,
  }),

  [FETCH_APPOINTMENTS_ESTIMATED_TIME.success]: (state, { payload }) => ({
    ...state,
    value: keyBy(payload, 'appointmentId'),
    status: requestsStatuses.success,
  }),

  [UPDATE_ESTIMATED_TIME]: (state, { payload }) => {
    const tempState = state;
    payload.estimatedTimeToBeServedUpdate.map(estimatedTime => tempState.value[estimatedTime.appointmentId] = estimatedTime);

    return tempState;
  },
});
